import { ACTION_TYPES } from "./types"
import { StockDocumentDefinition, StockDocumentDefinitionListing } from "../models"

export const Action = {
    fetchListing: () => {
        return {
            type: ACTION_TYPES.FETCH_LISTING,
        }
    },

    fetchListingSuccess: (def: StockDocumentDefinitionListing) => {
        return {
            type: ACTION_TYPES.FETCH_LISTING_SUCCESS,
            payload: def,
        }
    },

    fetchSuccess: (def: StockDocumentDefinition) => {
        return {
            type: ACTION_TYPES.FETCH_SUCCESS,
            payload: def,
        }
    },

    //This action is used to set a new definition from the listing
    setFromListing: (id: string) => {
        return {
            type: ACTION_TYPES.SET_FROM_LISTING,
            payload: id,
        }
    }

}






// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/actions/actions.ts